// Packages
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// Components
import ListItem from 'modules/Contracts/components/ListItem';

// Other
import './styles.css';

const ContractList = ({ isLoading, items, onChange, query }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='ContractList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No results</h3>
		)
	}


	// Data State
	return (
		<div className='ContractList'>

			{items.map((item, index) => {

				return (
						<Link className='ContractList__link' to={'/contracts/' + item.id + (query !== '' ? '?query=' + query : '')} key={index}>
							<ListItem 
								{...item} 
								isLoading={false}
								onChange={() => {onChange()}}
							/>
						</Link>
				)
				
			})}

		</div>
	)
}

ContractList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
	query: PropTypes.string
}

ContractList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
	query: ''
}

export default ContractList;